import React from "react"
import Logo from "../components/assets/images/newweb.png"
import Background from "../components/assets/images/main-background.jpg"
import { IoMdPlayCircle } from "react-icons/io";
import { SiGoogleclassroom } from "react-icons/si";
import { FaNoteSticky } from "react-icons/fa6";
import { FaWhatsapp, FaTelegramPlane, FaYoutube, FaFacebook, FaTiktok } from "react-icons/fa"
import { MdOutlineShoppingCart } from "react-icons/md";
import { About } from "./About"
import { Instructor } from "./Instructor"
import { Talents } from "./Talents"
import Social from "./Social";
import Shop from "./Shop";
import { Slider } from "../components/common/Slider"
import ClassSchedule from "../components/common/ClassSchedule"
import { useNavigate } from "react-router-dom"
import NewsCard from "../components/common/NewsCard";


export const Home = () => {
  return (
    <div className="overflow-hidden">
      <HomeContent />
      <br />
      <NewsCard />
      <br />
      <Slider />
      <br />
      <ClassSchedule />
      <br />
      {/* <Review /> */}
      <br />
      <About />
      <br />
      <Shop isHomeScreen={true} />
      <br />
      <Social />
      <br />
      <Instructor />
      <br />
      <Talents />
    </div>
  )
}

export const HomeContent = () => {
  const navigate = useNavigate();

  return (
    <>
      <section style={{ backgroundImage: `url(${Background})` }} className='bg-cover py-10 h-[92vh] md:h-full overflow-hidden'>
        <div className='container'>
          <div className='flex items-center justify-center md:flex-col'>
            <div className='left w-1/2 text-black md:w-full'>
              <h1 className='text-4xl leading-tight text-white font-semibold'>
                Welcome To <br /> Kuppi Media <br /> online learning Platform
              </h1>
              <span className='text-white  font-medium lowercase'>
                <strong>kuppimedia.lk</strong> කියන්නේ ඉගෙන ගන්න අපි වෙනුවෙන් හැදුණු තැනක්!. <br />
                ඔයාට ඕනි කරන <strong>notes</strong>  හොයාගන්න, <br />
                කුප්පි දාන්න,කුප්පි <strong>recordings</strong>  බලන්න, <br />
                <strong>Tuition</strong>  හොයාගන්න,<br />
                ඔයාලගෙ චූටි බිස්නස් එක <strong>promote</strong>  කරගන්න, <br />
                අපේ යාලුවන්ගේ දේවල් මිලදී ගන්න,<br />
                දක්ෂතා පෙන්නන්න හදපු තැනක් තමයි මේ.සරලවම කිව්වොත් අපි වෙනුවෙන් අපේ තැනක් !  <br /><strong>kuppimedia.lk</strong>
              </span>
              <div className='social-icons flex justify-start mt-6 space-x-4'>
                <a
                  href='https://whatsapp.com/channel/0029Va4kKdjCXC3BqCB9Xp3r'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-green-500'
                >
                  <FaWhatsapp size={30} />
                </a>
                <a
                  href='https://t.me/+LdcOGFDOYD0xNDg1'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-blue-400'
                >
                  <FaTelegramPlane size={30} />
                </a>
                <a
                  href='https://youtube.com/@asiridevinda6400'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-red-500'
                >
                  <FaYoutube size={30} />
                </a>
                <a
                  href='https://www.facebook.com/profile.php?id=100091257086281&mibextid=LQQJ4d'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-blue-600'
                >
                  <FaFacebook size={30} />
                </a>
                <a
                  href='https://www.tiktok.com/@kuppimedia?is_from_webapp=1&sender_device=pc'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-black'
                >
                  <FaTiktok size={30} />
                </a>
              </div>
            </div>
            <div className='right w-1/2 md:w-80 relative lg:w-80'>
              <div className='images relative lg:mt-20'>
                <div className='img h-[40vh] w-full lg:mt-20'>
                  <img
                    src={`${Logo}`}
                    alt=''
                    className='mt-10 lg:m-5 w-full object-contain z-20 relative'
                  />
                </div>
              </div>
              <div className='content flex flex-col items-center justify-center gap-2 md:flex-column lg:flex-row lg:mt-20 mt-5'>
                <button
                  className='bg-white h-16 md:h-15 shadow-lg hover:shadow-xl mt-4 p-2 md:p-3 flex items-center rounded-xl transition-all duration-300 hover:-translate-y-1 group md:w-auto'
                  onClick={() => { navigate("/youtube") }}>
                  <IoMdPlayCircle size={35} className='md:size-20 ml-1' />
                  <div className='text flex flex-column px-3 md:px-4  m-1 items-start'>
                    <span className='text-lg md:text-sm font-medium text-gray-800 whitespace-nowrap'>Find</span>
                    <span className='text-sm md:text-xs font-regular text-gray-600 tracking-wide whitespace-nowrap'>Kuppi Recording</span>
                  </div>
                </button>
                <button
                  className='bg-white h-16 md:h-15 shadow-lg hover:shadow-xl mt-4 p-2 md:p-3 flex items-center rounded-xl transition-all duration-300 hover:-translate-y-1 group md:w-auto'
                  onClick={() => { navigate("/notes") }}>
                  <FaNoteSticky size={30} className='md:size-20 ml-1' />
                  <div className='text flex flex-column px-3 md:px-4  m-1 items-start'>
                    <span className='text-lg md:text-sm font-medium text-gray-800 whitespace-nowrap'>Find</span>
                    <span className='text-sm md:text-xs font-regular text-gray-600 tracking-wide whitespace-nowrap'>Kuppi Notes</span>
                  </div>
                </button>

                <button
                  className='bg-white h-16 md:h-15 shadow-lg hover:shadow-xl mt-4 p-2 md:p-3 flex items-center rounded-xl transition-all duration-300 hover:-translate-y-1 group md:w-auto'
                  onClick={() => { navigate("/profile") }}>
                  <SiGoogleclassroom size={30} className='md:size-20 ml-1' />
                  <div className='text flex flex-column px-3 md:px-4  m-1 items-start'>
                    <span className='text-lg md:text-sm font-medium text-gray-800 whitespace-nowrap'>Find</span>
                    <span className='text-sm md:text-xs font-regular text-gray-600 tracking-wide whitespace-nowrap'>Tution Class</span>
                  </div>
                </button>
                <button
                  className='bg-white h-16 md:h-15 shadow-lg hover:shadow-xl mt-4 p-2 md:p-3 flex items-center rounded-xl transition-all duration-300 hover:-translate-y-1 group md:w-auto'
                  onClick={() => { navigate("/shop") }}>
                  <MdOutlineShoppingCart size={30} className='md:size-20 ml-1' />
                  <div className='text flex flex-column px-3 md:px-4  m-1 items-start'>
                    <span className='text-lg md:text-sm font-medium text-gray-800 whitespace-nowrap'>Shop in</span>
                    <span className='text-sm md:text-xs font-regular text-gray-600 tracking-wide whitespace-nowrap'>PRODUCTS & SERVICES</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}